
import "./Footer.scss";

import vk from '../../assets/img/vk.png'
import youTube from '../../assets/img/youTube.png'
import ok from '../../assets/img/ok.png'
import telegram from '../../assets/img/telegram.png'

export const Footer = () => {


  return (
    <footer className="footer">
      <div className="container footer__container">
        <ul className="footer__list">
          <li className="footer__item">
            <a target="_blank" className="footer__link" href="https://vk.com">
              <img className="footer__img footer__img_vk" src={vk} alt="vk" /></a>
          </li>
          <li className="footer__item">
            <a target="_blank" className="footer__link" href="https://www.youtube.com">
              <img className="footer__img footer__img_youtube" src={youTube} alt="youtube" /></a>
          </li>
          <li className="footer__item">
            <a target="_blank" className="footer__link" href="https://ok.ru">
              <img className="footer__img footer__img_ok" src={ok} alt="ok" /></a>
          </li>
          <li className="footer__item">
            <a target="_blank" className="footer__link" href="https://t.me/s/telegram">
              <img className="footer__img footer__img_telegram" src={telegram} alt="telegram" /></a>
          </li>
        </ul>
      </div>
    </footer>
  );
};
